import React from 'react';
import { NavLink } from "react-router-dom";

class Tile extends React.Component {
	render() {

		const style = this.props.bg ? {backgroundImage: `url(${this.props.bg})`} : {};
		if(this.props.transparent) style.backgroundColor = 'transparent';

		if(this.props.url) {
			return (
				<NavLink to={this.props.url} activeClassName="active" 
	        	 className="tile" style={style}>
	        	 	<div className="tileInner">{this.props.text}</div>
	        	 </NavLink>
			);
		} else {
			return (
				<div className="tile" style={style}>
	        	 	<div className="tileInner">{this.props.text}</div>
	        	 </div>
			);
		}
	}
}


export default Tile


// WEBPACK FOOTER //
// ./src/components/Tile.js